import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Img,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import iconAdd from "../../assets/images/projectManagement/icon-add-project.svg";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import { AiOutlineMore } from "react-icons/ai";
import iconDetail from "../../assets/images/projectManagement/icon-detail.svg";
import iconEdit from "../../assets/images/projectManagement/icon-edit.svg";
import iconUnlock from "../../assets/images/projectManagement/icon-unlock.svg";
import iconClock from "../../assets/images/projectManagement/lock.svg";
import { formatTableValue } from "./formatTable";
import PopupProjectManagementAdd from "../../components/popup/popupProjectManagementAdd";
import PopupProjectManagementTitle from "../../components/popup/popupProjectManagementTitle";
import FileDownload from "../../components/popup/popupFileProject";
import { useProjectManagement } from "../../hooks/projectManagement";
import ReactPaginate from "react-paginate";
import toast from "react-hot-toast";
import { commonCall } from "../../api/common";
import { projectCall } from "../../api/project";
import { projectManagerCall } from "../../api/projectManager";
import { projectDocumentCall } from "../../api/projectDocument";
import { projectImageCall } from "../../api/projectImage";
import icontrash from "../../assets/images/product/trash.svg";
import DeleteDialog from "../../components/dialog/delete";
import useDebounce from "../../hooks/useDebounce";
import { SearchIcon } from "@chakra-ui/icons";
import SearchableSelect from "../../components/selectForm";
import {
  AgentProject,
  StatusIsAllowTtkq,
  StatusIsProjectMechanismParameters,
  StatusProject,
} from "../../utils/contants";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import { useSelector } from "react-redux";
import { employeeCall } from "../../api/employee";
// import { useNavigate } from "react-router-dom";
const REACT_APP_ROUTE_RATE =
  process.env.REACT_APP_ROUTE_RATE ||
  "MSH_RATE_PRODUCT_AND_APARTMENT_MANAGEMENT";

const ProjectManagement = () => {
  //  const navigate = useNavigate();
  const {
    isOpen: isParentOpen,
    onOpen: onOpenParent,
    onClose: onCloseParent,
    onToggle: onToggleParent,
  } = useDisclosure();
  const {
    isOpen: isOpenTitle,
    onOpen: onOpenTitle,
    onClose: onCloseTitle,
    onToggle: onToggleTitle,
  } = useDisclosure();
  const {
    isOpen: isOpenDownloadFile,
    onOpen: onOpenDownloadFile,
    onClose: onCloseDownloadFile,
    onToggle: onToggleDownloadFile,
  } = useDisclosure();
  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
    onToggle: onToggleDelete,
  } = useDisclosure();

  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [status, setStatus] = useState(null);
  const [isAllowTtkq, setIsAllowTtkq] = useState(null);
  const [isProjectMechanismParameters, setIsProjectMechanismParameters] =
    useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [fileDownload, setFileDownload] = useState([]);
  const [popupDelete, setPopupDelete] = useState(false);
  const [agent, setAgent] = useState(false);
  const [date, setDate] = useState(null);
  const user = useSelector((state) => state.auth.login?.currentUser);
  const [getRoleUser, setGetRoleUser] = useState(false);

  const {
    projectManagementData,
    totalPages,
    refetch,
    isLoading,
    isRefetching,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useProjectManagement(
    debouncedSearch,
    status,
    isAllowTtkq,
    isProjectMechanismParameters,
    agent,
    date,
  );

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const handleChange = (update) => {
    setDate(update);
  };

  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const fetchDataUser = async (id) => {
    try {
      const res = await employeeCall.roleUser(id);
      if (res?.group_role_code) {
        const hasRole = res?.group_role_code
          ?.split(",")
          .includes(REACT_APP_ROUTE_RATE);
        setGetRoleUser(hasRole);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDataUser(user?.user?._id);
  }, [user?.user?._id]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const historyTableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Ảnh",
        key: "image",
      },
      {
        label: "Trạng thái",
        key: "status",
      },
      {
        label: "Dự án",
        key: "nameproject",
      },
      {
        label: "TTKQ/VBTT/HĐTHNV",
        key: "is_allow_ttkq",
      },
      {
        label: "Cập nhật cơ chế dự án",
        key: "isProjectMechanismParameters",
      },
      {
        label: "Chủ đầu tư",
        key: "investor",
      },
      {
        label: "Phân loại",
        key: "projectType",
      },
      {
        label: "Loại đại lý",
        key: "agent",
      },
      {
        label: "Địa chỉ",
        key: "address",
      },
      {
        label: "Thành phố",
        key: "city",
      },
      {
        label: "Thời gian tiếp nhận",
        key: "received",
      },
      {
        label: "% PDV nhận từ CĐT (X)",
        key: "commissionFromInvestor",
      },
      {
        label: "% PDV trả cho sale (Y)",
        key: "commissionToSales",
      },
      {
        label: "% PDV nhận từ đối tác ngoài CĐT (Z)",
        key: "commissionFromPartner",
      },
      {
        label: "Tài liệu",
        key: "fileProject",
      },
      // {
      //   label: "Số tiền đặt cọc",
      //   key: "locking_price",
      // },
      // {
      //   label: "Số tiền booking",
      //   key: "booking_price",
      // },
    ],
    data: projectManagementData,
  };

  const onSetFile = (data) => {
    onOpenDownloadFile();
    setFileDownload(data);
  };

  const onDownLoad = (file) => {
    const link = document.createElement("a");
    link.target = "_blank";
    link.href = file;
    link.click();
    if (document.body.contains(link)) {
      document.body.removeChild(link);
    }
  };

  const onAdd = (e) => {
    onOpenParent();
    setDataEdit(null);
  };

  const onDetail = (e) => {
    setDataEdit(e?.detail);
    onOpenTitle();
  };

  const onEdit = (e) => {
    setDataEdit(e?.edit);
    onOpenParent();
  };

  const onCloseEdit = () => {
    setDataEdit(null);
    onCloseParent();
  };

  const handlePopupDelete = (e) => {
    setPopupDelete(true);
    setDataEdit(e?.edit);
    onOpenDelete();
  };

  const onSubmitDelete = async () => {
    const toastEdit = toast.loading("Đang xóa dữ liệu ...");
    try {
      const { id } = dataEdit;
      await projectManagerCall.delete(id);
      await refetch();
      setDataEdit(null);
      onCloseDelete();
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      if (error?.status !== 409) {
        toast.error("Có lỗi xảy ra khi xóa");
      }
    }
    toast.dismiss(toastEdit);
  };

  const updateStatus = async (e) => {
    const toastCreate = toast.loading("Đang cập nhập ...");
    try {
      await projectCall.updateStatus({
        id: e?.id,
      });

      await refetch();
      onToggleParent();
      onCloseTitle();
      onCloseEdit();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const onSubmitAdd = async (data) => {
    const toastCreate = toast.loading("Đang thêm dự án ...");

    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null,
        ),
      );

      const {
        employeeProject,
        fileProject,
        honor,
        imageHonor,
        project,
        imageProject,
        imageOther,
        ...filteredDatas
      } = filteredData;

      let uploadResultFileProjects = [];
      let uploadResultLinkFileProjects = fileProject.filter(
        (file) => file.linkFile && file.typeFile === true,
      );
      let filePathHonors = null;
      let filePathProjects = null;
      let uploadResultImageOthers = null;

      if (fileProject) {
        uploadResultFileProjects = await Promise.all(
          fileProject
            .filter((file) => file.file)
            .map(async (file) => {
              const uploadResult = await commonCall.uploadFile(
                file.file,
                "fileProject",
              );
              return {
                id: file.id,
                uploadResult,
              };
            }),
        );
      }

      if (honor) {
        filePathHonors = await commonCall.uploadAvatar(honor, "imageProject");
      }

      if (project) {
        filePathProjects = await commonCall.uploadAvatar(
          project,
          "imageProject",
        );
      }

      if (imageOther) {
        uploadResultImageOthers = await Promise.all(
          imageOther.map((file) =>
            commonCall.uploadFile(file?.file, "imageProject"),
          ),
        );
      }

      if (!getRoleUser) {
        delete filteredDatas?.commissionFromInvestor;
        delete filteredDatas?.commissionToSales;
        delete filteredDatas?.commissionFromPartner;
      }

      const dataCreateProject = await projectCall.create({
        ...filteredDatas,
        status: "OPEN",
      });

      if (dataCreateProject?._id) {
        // if(true){

        const id = dataCreateProject._id;

        // filter add projectManager
        let createDataEmployeeManager = [];
        if (employeeProject) {
          createDataEmployeeManager = employeeProject.map((item) => {
            if (item?.id) {
              delete item?.id;
            }
            item.projectId = id;
            return item;
          });
        }

        if (createDataEmployeeManager.length > 0) {
          await projectManagerCall.createMany(createDataEmployeeManager);
        }

        uploadResultFileProjects.push(...uploadResultLinkFileProjects);

        // Filter add projectDocument
        if (uploadResultFileProjects) {
          const validDocuments = uploadResultFileProjects
            .map((result, index) => {
              const file = fileProject.find((f) => f.id === result.id);

              if (result?.uploadResult?.filePath || result?.linkFile) {
                return {
                  projectId: id,
                  path: result?.uploadResult?.filePath || file?.linkFile || "",
                  name: file?.name || file?.nameFile || file?.file?.name || "",
                  typeFile: file?.typeFile || false,
                };
              }
              return null;
            })
            .filter(Boolean); // loại bỏ null

          if (validDocuments.length) {
            await projectDocumentCall.createMany(validDocuments);
          }
        }

        // Filter add image project
        if (filePathHonors) {
          // const { filePath } = await commonCall.uploadAvatar(
          //   honor,
          //   "imageProject"
          // );
          if (filePathHonors?.filePath) {
            await projectImageCall.create({
              projectId: id,
              path: filePathHonors?.filePath,
              type: "HONOR",
            });
          }
        }

        if (filePathProjects) {
          // const { filePath } = await commonCall.uploadAvatar(
          //   project,
          //   "imageProject"
          // );
          if (filePathProjects?.filePath) {
            await projectImageCall.create({
              projectId: id,
              path: filePathProjects?.filePath,
              type: "AVATAR",
            });
          }
        }

        // Filter add image other
        if (uploadResultImageOthers) {
          // const uploadResults = await Promise.all(
          //   imageOther.map((file) =>
          //     commonCall.uploadFile(file?.file, "imageProject")
          //   )
          // );

          const validImages = uploadResultImageOthers
            .map((result, index) => {
              const file = imageOther[index];
              if (result.filePath) {
                return {
                  projectId: id,
                  path: result.filePath,
                  type: "OTHER",
                  name: file?.name || file?.file?.name || "",
                };
              }
              return null;
            })
            .filter(Boolean); // loại bỏ null

          if (validImages.length) {
            await projectImageCall.createMany(validImages); // gửi dạng mảng
          }
        }
      }

      await refetch();
      onToggleParent();
      onCloseTitle();
      onCloseEdit();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      // toast.error("Lỗi khi thêm dự án");
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa dự án ...");

    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null,
        ),
      );

      delete filteredData?.nameProject;

      delete filteredData?.dataProjectManagers;

      delete filteredData?.file;

      const {
        id,
        employeeProject,
        fileProject,
        honor,
        imageHonor,
        project,
        imageProject,
        imageOther,
        ...filteredDatas
      } = filteredData;

      let uploadResultFileProjects = null;
      // let uploadResultLinkFileProjects = fileProject.filter(
      //   (file) =>
      //     file.linkFile && file.typeFile === true && file.status === true
      // );

      if (fileProject) {
        uploadResultFileProjects = await Promise.all(
          fileProject
            .filter((file) => file.file)
            .map(async (file) => {
              const uploadResult = await commonCall.uploadFile(
                file.file,
                "fileProject",
              );
              return {
                id: file.id,
                uploadResult,
              };
            }),
        );
      }
      // xử lý ảnh và file
      // Filter add projectDocument
      if (fileProject) {
        const filteredFiles = fileProject.filter((item) => item?.status);
        // console.log({fileProject})
        const filteredFileNews = fileProject.filter((item) => item?.file);

        const filteredIds = fileProject
          .filter((item) => !item?.status)
          .map((item) => item?.id || item?._id);

        const uploadResults = await Promise.all(
          filteredFileNews.map((file) =>
            commonCall.uploadFile(file.file, "fileProject"),
          ),
        );

        let validDocuments = [];
        // Filter add projectDocument
        if (fileProject) {
          validDocuments = filteredFiles
            .map((result, index) => {
              const file = uploadResultFileProjects.find(
                (f) => f.id === result.id,
              );

              if (result?.typeFile && result?.linkFile) {
                return {
                  projectId: id,
                  path: result?.linkFile || "",
                  name:
                    result?.nameFile ||
                    result?.name ||
                    result?.file?.name ||
                    "",
                  typeFile: result?.typeFile || false,
                };
              } else if (!result?.typeFile && (result?.file || result?.path)) {
                return {
                  projectId: id,
                  path:
                    file?.uploadResult?.filePath ||
                    result?.filePath ||
                    result?.path ||
                    "",
                  name:
                    result?.file?.name ||
                    result?.nameFile ||
                    result?.name ||
                    "",
                  typeFile: result?.typeFile || false,
                };
              }
              return null;
            })
            .filter(Boolean);
        }

        if (validDocuments.length) {
          await projectDocumentCall.updateMany(id, {
            dataUpdate: validDocuments,
            filteredIds,
          });
        }
      }

      // Filter add image project
      if (honor) {
        const { filePath } = await commonCall.uploadAvatar(
          honor,
          "imageProject",
        );
        if (filePath) {
          await projectImageCall.updateByProjectId({
            projectId: id,
            path: filePath,
            type: "HONOR",
          });
        }
      }

      if (project) {
        const { filePath } = await commonCall.uploadAvatar(
          project,
          "imageProject",
        );
        if (filePath) {
          await projectImageCall.updateByProjectId({
            projectId: id,
            path: filePath,
            type: "AVATAR",
          });
        }
      }

      // Filter add image other
      if (imageOther) {
        const filteredFiles = imageOther.filter(
          (item) => item?.file && item?.status,
        );

        const filteredFileExits = imageOther.filter(
          (item) => !item?.file && item?.status && item?.path,
        );

        const filteredIds = imageOther
          .filter((item) => !item?.status)
          .map((item) => item?.id || item?._id);

        const uploadResults = await Promise.all(
          filteredFiles.map((file) =>
            commonCall.uploadFile(file.file, "imageProject"),
          ),
        );

        const validDocuments = uploadResults
          .map((result, index) => {
            const file = filteredFiles[index];
            if (result.filePath) {
              return {
                projectId: id,
                path: result.filePath,
                type: "OTHER",
                name: file?.nameFile || file?.file?.name || "",
              };
            }
            return null;
          })
          .filter(Boolean);

        filteredFileExits.map((item) => {
          validDocuments.push({
            projectId: id,
            path: item.path,
            type: "OTHER",
            name: item?.nameFile || item?.file?.name || "",
          });
        });

        // console.log({validDocuments});
        if (validDocuments.length) {
          await projectImageCall.updateMany(id, {
            dataUpdate: validDocuments,
            filteredIds,
          });
        }
      }
      // kết thúc

      if (!getRoleUser) {
        delete filteredDatas?.commissionFromInvestor;
        delete filteredDatas?.commissionToSales;
        delete filteredDatas?.commissionFromPartner;
      }

      const dataCreateProject = await projectCall.update(id, {
        ...filteredDatas,
      });

      // filter add projectManager
      let createDataEmployeeManager = [];
      if (employeeProject && dataCreateProject?._id) {
        createDataEmployeeManager = employeeProject.map((item) => {
          if (item?.id) {
            delete item?.id;
          }
          item.projectId = id;
          return item;
        });
      }

      if (createDataEmployeeManager.length > 0) {
        await projectManagerCall.createMany(createDataEmployeeManager);
      }

      await refetch();
      onToggleTitle();
      onCloseTitle();
      onCloseEdit();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  // const handleNavigate = (e) => {
  //   navigate(
  //     `/project-management/updateProjectMechanism/${e?.id}`
  //   );
  // };

  return (
    <Box
      minH="calc(100vh - 80px)"
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px 15px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý dự án
          </Text>
        </Flex>

        <Flex alignItems={"center"} gap={"16px"}>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--color-button)"
            _hover={{
              backgroundImage: "var(--color-button)",
            }}
            onClick={() => onAdd()}
          >
            <Image src={iconAdd} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Thêm dự án
            </Text>
          </Button>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <Flex flexDirection={"column"} gap={{ base: "16px" }}>
          <Flex
            minHeight="calc(100vh - 167px)"
            backgroundColor="var(--color-main)"
            borderRadius={{ base: "12px" }}
            flexDirection={"column"}
          >
            <Flex
              alignItems={"center"}
              gap={{ base: "32px" }}
              p={"29px 0px 40px 16px"}
            >
              <Flex flexDirection={"column"} gap={{ base: "24px" }} flex={"1"}>
                <InputGroup
                  maxW="42vw"
                  minW={"42vw"}
                  borderRadius={{ base: "8px" }}
                >
                  <Input
                    placeholder="Nhập tên dự án..."
                    type="text"
                    borderRadius={{ base: "8px" }}
                    border={{ base: "1px solid var(--color-boder)" }}
                    onChange={onChangeSearch}
                  />
                  <InputRightElement
                    borderTopRightRadius={"8px"}
                    borderBottomRightRadius={"8px"}
                    pointerEvents="none"
                    backgroundImage="var(--color-button)"
                    cursor={"pointer"}
                  >
                    <SearchIcon color="var(--color-main)" />
                  </InputRightElement>
                </InputGroup>
                <Flex alignItems={"center"} flexWrap={"wrap"} gap={"24px"}>
                  <SearchableSelect
                    isShowSearch={false}
                    options={StatusProject}
                    initialSelectedOption={{
                      key: null,
                      value: "Trạng thái dự án",
                    }}
                    setValue={setStatus}
                  />
                  <SearchableSelect
                    isShowSearch={false}
                    options={StatusIsAllowTtkq}
                    initialSelectedOption={{
                      key: null,
                      value: "Trạng thái lên TTKQ",
                    }}
                    setValue={setIsAllowTtkq}
                  />

                  <SearchableSelect
                    isShowSearch={false}
                    options={StatusIsProjectMechanismParameters}
                    initialSelectedOption={{
                      key: null,
                      value: "Trạng thái cập nhật cơ chế dự án",
                    }}
                    setValue={setIsProjectMechanismParameters}
                  />
                  <SearchableSelect
                    isShowSearch={false}
                    options={AgentProject}
                    initialSelectedOption={{
                      key: null,
                      value: "Loại đại lý",
                    }}
                    setValue={setAgent}
                  />
                  <InputGroup maxW={"255px"} zIndex={3}>
                    <DatePicker
                      selected={date}
                      onChange={handleChange}
                      dateFormat="MM/yyyy"
                      showMonthYearPicker
                      isClearable={true}
                      placeholderText="Thời gian tiếp nhận"
                      className="datePickerStyle"
                      locale="vi"
                    />
                    {!date && (
                      <InputRightElement pointerEvents="none" h={"44px"}>
                        <Image src={calendarIcon} />
                      </InputRightElement>
                    )}
                  </InputGroup>
                </Flex>
              </Flex>
            </Flex>

            <Flex
              flexDirection={"column"}
              justifyContent={"space-between"}
              width={"100%"}
              minH="calc(100vh - 235px)"
            >
              <Skeleton isLoaded={!isLoading && !isRefetching}>
                <TableContainer
                  w={"100%"}
                  pb={"32px"}
                  maxH="calc(100vh - 350.5px)"
                  overflowY="auto"
                >
                  <Table w={"100%"} variant="unstyled">
                    <Thead
                      position="sticky"
                      top="0"
                      zIndex="1"
                      w={"100%"}
                      h={"41px"}
                      color="white"
                      fontWeight="400"
                      borderBottom={"1px solid var(--color-boder)"}
                      backgroundColor="var(--fill-avatar)"
                    >
                      <Tr h={{ base: "41px" }}>
                        {historyTableData.headers.map((e, index) => {
                          if (
                            !getRoleUser &&
                            [
                              "commissionFromInvestor",
                              "commissionToSales",
                              "commissionFromPartner",
                            ].includes(e.key)
                          ) {
                            return null;
                          }
                          let width = "auto";
                          let textAlign = "auto";
                          if (e.key === "") {
                            width = "3%";
                            textAlign = "center";
                          } else if (e.key === "id") {
                            width = "5%";
                            textAlign = "center";
                          } else if (e.key === "status") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "image") {
                            width = "15%";
                            textAlign = "start";
                          } else if (e.key === "nameproject") {
                            width = "15%";
                            textAlign = "start";
                          } else if (e.key === "investor") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "projectType") {
                            width = "15%";
                            textAlign = "start";
                          } else if (e.key === "is_allow_ttkq") {
                            width = "25%";
                            textAlign = "start";
                          } else if (e.key === "isProjectMechanismParameters") {
                            width = "25%";
                            textAlign = "start";
                          } else if (e.key === "address") {
                            width = "20%";
                            textAlign = "end";
                          } else {
                            width = "10%";
                            textAlign = "end";
                          }
                          return (
                            <Td
                              p={"16px 16px 12px 16px"}
                              key={index}
                              border={"none"}
                              color={"#51607B"}
                              fontSize={{ base: "14px" }}
                              w={width}
                            >
                              <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                            </Td>
                          );
                        })}
                      </Tr>
                    </Thead>
                    <Tbody w={"100%"} h={"100%"}>
                      {historyTableData.data?.length > 0 ? (
                        historyTableData.data?.map((e, rowIndex) => {
                          const items = { ...e };
                          delete items.id;
                          // delete items.status;
                          delete items.edit;
                          delete items.detail;
                          if (!getRoleUser) {
                            delete items.commissionFromPartner;
                            delete items.commissionToSales;
                            delete items.commissionFromInvestor;
                          }

                          const keyValues = Object.keys(items);

                          return (
                            <Tr
                              w={"100%"}
                              key={rowIndex}
                              h={"86px"}
                              backgroundColor={
                                rowIndex % 2 === 0
                                  ? "#transparent"
                                  : "var(--fill-avatar)"
                              }
                            >
                              <Td
                                p={"16px 16px 8px 16px"}
                                verticalAlign={"top"}
                              >
                                <Menu>
                                  <MenuButton
                                    _hover={{ backgroundColor: "none" }}
                                    _active={{ backgroundColor: "none" }}
                                    background="none"
                                    as={Button}
                                    alignItems={"unset"}
                                  >
                                    <AiOutlineMore fontSize={"20px"} />
                                  </MenuButton>
                                  <MenuList>
                                    <MenuItem
                                      alignItems={"center"}
                                      display={"flex"}
                                      gap={"16px"}
                                      onClick={() => onDetail(e)}
                                    >
                                      <Image src={iconDetail} />
                                      <Text
                                        fontSize={{ base: "14px" }}
                                        fontWeight={500}
                                        lineHeight={"140%"}
                                        color="var(--color-option-employee)"
                                      >
                                        Xem chi tiết
                                      </Text>
                                    </MenuItem>
                                    <MenuItem
                                      alignItems={"center"}
                                      display={"flex"}
                                      gap={"16px"}
                                      onClick={() => onEdit(e)}
                                    >
                                      <Image src={iconEdit} />
                                      <Text
                                        fontSize={{ base: "14px" }}
                                        fontWeight={500}
                                        lineHeight={"140%"}
                                        color="var(--color-option-employee)"
                                      >
                                        Chỉnh sửa
                                      </Text>
                                    </MenuItem>
                                    {/* <MenuItem
                                      gap={"16px"}
                                      onClick={() => handleNavigate(e)}
                                    >
                                      <Image src={iconEdit} /> Cập nhật cơ chế
                                      dự án
                                    </MenuItem> */}
                                    {e?.status === "OPEN" && (
                                      <MenuItem
                                        alignItems={"center"}
                                        display={"flex"}
                                        gap={"16px"}
                                        onClick={() => updateStatus(e)}
                                      >
                                        <Image src={iconClock} />
                                        <Text
                                          fontSize={{ base: "14px" }}
                                          fontWeight={500}
                                          lineHeight={"140%"}
                                          color="var(--color-option-employee)"
                                        >
                                          Đóng dự án
                                        </Text>
                                      </MenuItem>
                                    )}
                                    {e?.status === "CLOSE" && (
                                      <MenuItem
                                        alignItems={"center"}
                                        display={"flex"}
                                        gap={"16px"}
                                        onClick={() => updateStatus(e)}
                                      >
                                        <Image src={iconUnlock} />
                                        <Text
                                          fontSize={{ base: "14px" }}
                                          fontWeight={500}
                                          lineHeight={"140%"}
                                          color="var(--color-option-employee)"
                                        >
                                          Mở dự án
                                        </Text>
                                      </MenuItem>
                                    )}
                                    <MenuItem
                                      alignItems={"center"}
                                      display={"flex"}
                                      gap={"16px"}
                                      onClick={() => handlePopupDelete(e)}
                                    >
                                      <Image src={icontrash} />
                                      <Text
                                        fontSize={{ base: "14px" }}
                                        fontWeight={500}
                                        lineHeight={"140%"}
                                        color="var(--color-option-employee)"
                                      >
                                        Xóa dự án
                                      </Text>
                                    </MenuItem>
                                  </MenuList>
                                </Menu>
                              </Td>
                              <Td
                                p={"16px 16px 8px 16px"}
                                verticalAlign={"top"}
                              >
                                {rowIndex + 1}
                              </Td>
                              {keyValues.map((keyvalue, index) => {
                                let width = "auto";
                                let widthText = "100%";
                                let textAlign = "auto";
                                let whiteSpace = "inherit";
                                let minW = "auto";
                                if (keyvalue === "") {
                                  width = "3%";
                                  textAlign = "center";
                                } else if (keyvalue === "id") {
                                  width = "5%";
                                  textAlign = "center";
                                } else if (keyvalue === "image") {
                                  width = "15%";
                                  textAlign = "start";
                                } else if (keyvalue === "status") {
                                  width = "15%";
                                  textAlign = "start";
                                  minW = "max-content";
                                } else if (keyvalue === "nameproject") {
                                  width = "15%";
                                  textAlign = "start";
                                  whiteSpace = "normal";
                                  widthText = "227px";
                                } else if (keyvalue === "investor") {
                                  width = "10%";
                                  textAlign = "start";
                                  whiteSpace = "normal";
                                  widthText = "261px";
                                } else if (keyvalue === "projectType") {
                                  width = "15%";
                                  textAlign = "start";
                                } else if (keyvalue === "is_allow_ttkq") {
                                  width = "25%";
                                  textAlign = "start";
                                } else if (
                                  keyvalue === "isProjectMechanismParameters"
                                ) {
                                  width = "25%";
                                  textAlign = "start";
                                } else if (keyvalue === "address") {
                                  width = "20%";
                                  textAlign = "end";
                                } else {
                                  width = "10%";
                                  textAlign = "end";
                                }
                                return (
                                  <Td
                                    p={"16px 16px 8px 16px"}
                                    w={width}
                                    key={index}
                                    bg={
                                      rowIndex % 2 === 0
                                        ? "var(--color-main)"
                                        : "var(--fill-avatar)"
                                    }
                                    verticalAlign={"top"}
                                  >
                                    <Box
                                      fontSize={{ base: "14px" }}
                                      lineHeight={"19.6px"}
                                      textAlign={"start"}
                                      fontWeight={500}
                                      color={"#293755"}
                                      w={widthText}
                                      whiteSpace={whiteSpace}
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                      display="-webkit-box"
                                      minW={minW}
                                      sx={{
                                        WebkitLineClamp: "3",
                                        WebkitBoxOrient: "vertical",
                                      }}
                                    >
                                      {keyvalue === "fileProject"
                                        ? formatTableValue(
                                            e[keyvalue],
                                            keyvalue,
                                            onSetFile,
                                            e,
                                          )
                                        : formatTableValue(
                                            e[keyvalue],
                                            keyvalue,
                                          )}
                                    </Box>
                                  </Td>
                                );
                              })}
                            </Tr>
                          );
                        })
                      ) : (
                        <Tr>
                          <Td
                            colSpan={historyTableData.headers.length}
                            textAlign="center"
                            padding={"40px 0"}
                          >
                            Không có dữ liệu
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Skeleton>
              <Flex
                m={"50px 16px 16px 16px"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Text
                  fontSize={"14px"}
                  fontWeight={500}
                  lineHeight={"20px"}
                  color={"var(--text-color-Subtittle)"}
                >
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Flex>
          </Flex>
          <PopupProjectManagementAdd
            isOpen={isParentOpen}
            onClose={dataEdit ? onCloseEdit : onCloseParent}
            onSubmit={dataEdit ? onSubmitEdit : onSubmitAdd}
            isEdit={dataEdit ? true : false}
            defaultValues={dataEdit || {}}
            refetch={refetch}
          />
          <PopupProjectManagementTitle
            isOpen={isOpenTitle}
            onClose={onCloseTitle}
            defaultValue={dataEdit || []}
          />
          <FileDownload
            isOpen={isOpenDownloadFile}
            onClose={onCloseDownloadFile}
            files={fileDownload}
            onDownLoad={onDownLoad}
          />
          <DeleteDialog
            isOpen={isOpenDelete}
            onClose={onCloseDelete}
            title="Xóa dự án"
            description={
              <Flex display={"inline"}>
                "Bạn có chắc chắn muốn xóa dự{" "}
                <Text fontWeight={"600"} display={"inline"}>
                  {dataEdit?.name}
                </Text>{" "}
                này không?"
              </Flex>
            }
            action={() => onSubmitDelete()}
          />
        </Flex>
      </Box>
    </Box>
  );
};

export default ProjectManagement;
